import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "collectiveSection", "soloSection"]

  declare readonly selectTarget: HTMLSelectElement
  declare readonly collectiveSectionTarget: HTMLElement
  declare readonly soloSectionTarget: HTMLElement

  connect() {
    this.toggle()
  }

  toggle() {
    const type = this.selectTarget.value

    this.collectiveSectionTarget.hidden = type !== "group"
    this.soloSectionTarget.hidden = type === "group"
  }
}
